import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api-client';

export interface ShowingTypeOption {
  id: number;
  code: string;
  label: string;
  is_active: boolean;
  sort_order: number;
}

/**
 * Fetch all active showing types from the API.
 * Mirrors CMS CPIVTP system table (MKIVTP column on FPCPMK).
 */
export function useShowingTypes() {
  return useQuery<ShowingTypeOption[]>({
    queryKey: ['showing-types'],
    queryFn: async () => {
      const response = await get<{
        success: boolean;
        data: { showingTypes: ShowingTypeOption[] };
      }>('/showing-types');
      return response.data.showingTypes;
    },
    staleTime: 30 * 60 * 1000, // 30 minutes — values rarely change
  });
}
